module.exports = __webpack_public_path__ + "static/media/lattjo.3c493a49.png";


//////////////////
// WEBPACK FOOTER
// ./src/lattjo.png
// module id = 254
// module chunks = 0